module.exports = __webpack_public_path__ + "static/media/bt-clasifications-square.37812e44.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/bt-clasifications-square.png
// module id = 669
// module chunks = 0